import { useState } from "react";

import { useAuth } from "../context/AuthContext";
import { copy, edit, info, threedots, trash } from "../assets";
import { deleteBookmark } from "../database";

const Item = ({ item, handleSelectedItem, openItemForm, child }: any) => {
  const { id, title, url, description, folderId } = item;
  const { authUser } = useAuth();
  const [showMenu, setShowMenu] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const isOwner = authUser?.email === item.createdBy;

  const handleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleEditItem = () => {
    openItemForm();
    handleSelectedItem({ id, title, url, description, folderId });
    setShowMenu(false);
  };

  const handleDeleteItem = async () => {
    const confirm = window.confirm("Are you sure you want to delete this?");
    if (!confirm) return;
    await deleteBookmark(id, authUser?.email);
  };

  return (
    <>
      <div
        style={{
          backgroundColor: child ? "var(--secondary-color)" : "#FFFFFF",
        }}
        className="item"
      >
        <div className='item-box'>
          <a href={url} title={url} target='_blank' rel='noreferrer'>
            {title ? title : url}
          </a>
          <div>
            <span className='icon' onClick={handleMenu}>
              <img src={threedots} alt='three dots icon' />
              {showMenu && (
                <div
                  className={`item-menu ${showMenu ? "slide-in" : "slide-out"}`}
                >
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(url);
                    }}
                    title='Copy'
                  >
                    <img src={copy} alt='copy icon' />
                  </button>
                  {isOwner && (
                    <>
                      <button onClick={handleEditItem}>
                        <img src={edit} alt='edit icon' />
                      </button>
                      <button onClick={handleDeleteItem}>
                        <img src={trash} alt='trash icon' />
                      </button>
                    </>
                  )}
                  {description && (
                    <button
                      onClick={() => setShowDescription(!showDescription)}
                    >
                      <img src={info} alt='info icon' />
                    </button>
                  )}
                </div>
              )}
            </span>
          </div>
        </div>
        {showDescription && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              padding: 4,
              marginBottom: 4,
            }}
          >
            <p>~ {description}</p>
            <button
              style={{ color: "red" }}
              onClick={() => setShowDescription(false)}
            >
              X
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Item;
